module.exports = __webpack_public_path__ + "img/code@2x.b8ea24cb.png";